import cx from 'classnames'
import { type HTMLProps } from 'react'

import styles from './button.module.scss'

export function Button({
  className,
  theme = 'primary',
  type = 'button',
  ...props
}: HTMLProps<HTMLButtonElement> & { theme?: 'primary' | 'secondary' }) {
  return (
    <button
      className={cx(styles.button, className)}
      type={type as 'button' | 'submit' | 'reset'}
      data-theme={theme}
      {...props}
    />
  )
}
